export default __webpack_public_path__ + "static/B0187-d910cc98a65bdf77d7b1adfcb7c7f5c4.png";